import icon from 'assets/img/icons/icon-warning.svg'
import useProfile from 'hooks/useProfile'

const PurchaseWindowFail = ({ close }) => {
  const {errorText} = useProfile();

  const getAdditionalTitle = (errorText) => {
    if (errorText === '') {
      return 'Purchase Declined!';
    }

    if (errorText.includes('no event card found for collection')) {
      return 'No Eligible Events';
    }

    if (errorText.includes('Insufficient funds')) {
      return 'Insufficient Funds';
    }

    // Если ни одно из условий не выполнено, вернуть дефолтное значение
    return 'Error';
  };

  const getAdditionalText = (errorText) => {
    if (errorText === '') {
      return 'Your purchase was not completed.';
    }

    if (errorText.includes('no event card found for collection')) {
      return 'You cannot purchase this pack. There are no eligible events remaining in this collection.';
    }

    if (errorText.includes('Insufficient funds')) {
      return 'You do not have enough funds to complete this purchase.';
    }

    // Если ни одно из условий не выполнено, вернуть дефолтное значение
    return 'An unexpected error occurred.';
  };

  return (
    <>
      <header className="modal-window__header">
        <img src={icon} className="modal-window__icon" alt="" />
        <h5 className="modal-window__title">{getAdditionalTitle(errorText)}</h5>
        <p className="modal-window__info">
          {getAdditionalText(errorText)}
        </p>
      </header>
      <footer className="modal-window__footer">
        <button className="modal-window__footer-close" onClick={close}>Done</button>
      </footer>
    </>
  )
}

export default PurchaseWindowFail
